{
  "granite_boulder": {
    "name": "granite_boulder",
    "geometryId": "granite-rock",
    "materialId": "granite-rock",
    "cullDistance": 1800,
    "impostor": {
      "fromDistance": 50,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 2.2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 6
    },
    "yOffset": -0.15,
    "alignToNormal": 1,
    "footprint": 6,
    "collider": {
      "type": "box",
      "size": [
        2.23,
        2.12,
        1.25
      ]
    }
  },
  "granite_pebble_01": {
    "name": "granite_pebble_01",
    "geometryId": "granite-pebble-01",
    "lodDistances": [
      50
    ],
    "cullDistance": 120,
    "jitter": {
      "scale": {
        "from": 1,
        "to": 1.2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 1,
    "yOffset": -0.025,
    "footprint": 2.7,
    "castShadow": false
  },
  "alien_plant": {
    "name": "alien_plant",
    "geometryId": "alient-plant",
    "cullDistance": 130,
    "impostor": {
      "fromDistance": 80,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 0.7,
        "to": 1.3
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 4
    },
    "alignToNormal": 0,
    "footprint": 5,
    "collider": {
      "type": "capsule",
      "radius": 0.45,
      "height": 7.5
    },
    "wind": {
      "amplitude": 0.35,
      "frequency": 0.55,
      "flutter": 0.4
    }
  },
  "oak_01": {
    "name": "oak_01",
    "geometryId": "oak-01",
    "lodDistances": [
      60
    ],
    "cullDistance": 2600,
    "impostor": {
      "fromDistance": 400,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 0.9,
        "to": 1.6
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 9.5,
    "collider": {
      "type": "capsule",
      "radius": 0.65,
      "height": 3.39,
      "offset": [
        0,
        2.35,
        0
      ]
    },
    "wind": {
      "amplitude": 8,
      "frequency": 0.55,
      "flutter": 0.6
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": true
  },
  "poplar_01": {
    "name": "poplar_01",
    "geometryId": "poplar-01",
    "lodDistances": [
      60
    ],
    "cullDistance": 1600,
    "impostor": {
      "fromDistance": 400,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.25
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 6.4,
    "collider": {
      "type": "capsule",
      "radius": 0.46,
      "height": 2.85,
      "offset": [
        0,
        1.89,
        0
      ]
    },
    "wind": {
      "amplitude": 10,
      "frequency": 0.55,
      "flutter": 0.6
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": true
  },
  "plains_01": {
    "name": "plains_01",
    "geometryId": "plains-01",
    "cullDistance": 420,
    "impostor": {
      "fromDistance": 120,
      "views": 2,
      "tileSize": 64
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.3
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 2
    },
    "alignToNormal": 0.6,
    "yOffset": -0.132,
    "footprint": 1.6,
    "wind": {
      "amplitude": 5.18,
      "frequency": 0.8,
      "flutter": 0.7
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": false
  },
  "plains_02": {
    "name": "plains_02",
    "geometryId": "plains-02",
    "cullDistance": 420,
    "impostor": {
      "fromDistance": 120,
      "views": 4,
      "tileSize": 64
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.3
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 2
    },
    "alignToNormal": 0.6,
    "yOffset": -0.132,
    "footprint": 1.6,
    "wind": {
      "amplitude": 5.18,
      "frequency": 0.8,
      "flutter": 0.7
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": false
  },
  "palm_01": {
    "name": "palm_01",
    "geometryId": "palm-01",
    "lodDistances": [
      70
    ],
    "cullDistance": 2800,
    "impostor": {
      "fromDistance": 800,
      "views": 8,
      "tileSize": 64
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.25
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 4.8,
    "collider": {
      "type": "capsule",
      "radius": 0.34,
      "height": 11.32,
      "offset": [
        0,
        6,
        0
      ]
    },
    "wind": {
      "amplitude": 4.6,
      "frequency": 0.4,
      "flutter": 0.5
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": true
  },
  "palm_02": {
    "name": "palm_02",
    "geometryId": "palm-02",
    "lodDistances": [
      70
    ],
    "cullDistance": 2800,
    "impostor": {
      "fromDistance": 800,
      "views": 8,
      "tileSize": 64
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.25
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 7,
    "collider": {
      "type": "capsule",
      "radius": 0.55,
      "height": 8.9,
      "offset": [
        0,
        5,
        0
      ]
    },
    "wind": {
      "amplitude": 4.6,
      "frequency": 0.4,
      "flutter": 0.5
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": true
  },
  "palm_03": {
    "name": "palm_03",
    "geometryId": "palm-03",
    "lodDistances": [
      70
    ],
    "cullDistance": 1800,
    "impostor": {
      "fromDistance": 600,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.25
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 6.8,
    "collider": {
      "type": "capsule",
      "radius": 0.92,
      "height": 18.66,
      "offset": [
        0,
        10.25,
        0
      ]
    },
    "wind": {
      "amplitude": 4.5,
      "frequency": 0.4,
      "flutter": 0.5
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": true
  },
  "palm_04": {
    "name": "palm_04",
    "geometryId": "palm-04",
    "cullDistance": 220,
    "impostor": {
      "fromDistance": 120,
      "views": 4,
      "tileSize": 64
    },
    "jitter": {
      "scale": {
        "from": 0.7,
        "to": 1.3
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 2.3,
    "collider": {
      "type": "capsule",
      "radius": 0.23,
      "height": 0.54,
      "offset": [
        0,
        0.5,
        0
      ]
    },
    "wind": {
      "amplitude": 2.15,
      "frequency": 0.9,
      "flutter": 0.6
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": true
  },
  "desert_plains_01": {
    "name": "desert_plains_01",
    "geometryId": "plains-01",
    "cullDistance": 520,
    "impostor": {
      "fromDistance": 220,
      "views": 2,
      "tileSize": 32
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.3
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "yOffset": -0.084,
    "alignToNormal": 0.6,
    "footprint": 1.6,
    "wind": {
      "amplitude": 4.18,
      "frequency": 0.8,
      "flutter": 0.7
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": false
  },
  "cypress_01": {
    "name": "cypress_01",
    "geometryId": "cypress-01",
    "lodDistances": [
      60
    ],
    "cullDistance": 1800,
    "impostor": {
      "fromDistance": 400,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.25
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 1.6,
    "collider": {
      "type": "capsule",
      "radius": 0.23,
      "height": 17.54,
      "offset": [
        0,
        9,
        0
      ]
    },
    "wind": {
      "amplitude": 12,
      "frequency": 0.45,
      "flutter": 0.15
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": true
  },
  "cardinal_flower_01": {
    "name": "cardinal_flower_01",
    "geometryId": "cardinal-flower-01",
    "cullDistance": 220,
    "impostor": {
      "fromDistance": 120,
      "views": 4,
      "tileSize": 32
    },
    "jitter": {
      "scale": {
        "from": 0.8,
        "to": 1.2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 7
    },
    "alignToNormal": 0.6,
    "yOffset": -0.054,
    "footprint": 1.26,
    "wind": {
      "amplitude": 1.2,
      "frequency": 1.1,
      "flutter": 0.4
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": false
  },
  "fern_01": {
    "name": "fern_01",
    "geometryId": "fern-01",
    "cullDistance": 220,
    "impostor": {
      "fromDistance": 120,
      "views": 4,
      "tileSize": 64
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 1.5
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 4
    },
    "alignToNormal": 0.6,
    "yOffset": -0.036,
    "footprint": 2.37,
    "wind": {
      "amplitude": 2.15,
      "frequency": 0.9,
      "flutter": 0.6
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": false
  },
  "fern_02": {
    "name": "fern_02",
    "geometryId": "fern-02",
    "cullDistance": 220,
    "impostor": {
      "fromDistance": 120,
      "views": 4,
      "tileSize": 64
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 1.6
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 4
    },
    "alignToNormal": 0.6,
    "yOffset": -0.038,
    "footprint": 2.1,
    "wind": {
      "amplitude": 2.15,
      "frequency": 0.9,
      "flutter": 0.6
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": false
  },
  "thistle_01": {
    "name": "thistle_01",
    "geometryId": "thistle-01",
    "cullDistance": 420,
    "impostor": {
      "fromDistance": 110,
      "views": 2,
      "tileSize": 32
    },
    "jitter": {
      "scale": {
        "from": 0.9,
        "to": 1.1
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 4
    },
    "alignToNormal": 0.6,
    "yOffset": -0.06,
    "footprint": 1.6,
    "wind": {
      "amplitude": 2.18,
      "frequency": 0.8,
      "flutter": 0.7
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": false
  },
  "granite_01": {
    "name": "granite_01",
    "geometryId": "granite-01",
    "lodDistances": [
      50
    ],
    "cullDistance": 800,
    "impostor": {
      "fromDistance": 120,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 8
    },
    "alignToNormal": 1,
    "yOffset": -0.45,
    "footprint": 2.8,
    "collider": {
      "type": "hull",
      "points": [
        -1.361,
        0.391,
        -0.476,
        -1.451,
        0.341,
        0.203,
        -1.044,
        0.269,
        0.723,
        -1.213,
        1.34,
        -1.027,
        -1.763,
        1.153,
        -0.123,
        -0.838,
        0.692,
        1.013,
        -1.372,
        1.825,
        -0.672,
        -1.608,
        1.828,
        0,
        -1.135,
        2.114,
        0.524,
        -0.366,
        0.12,
        -0.563,
        -0.814,
        0.005,
        -0.417,
        0.128,
        0.367,
        1.081,
        -0.731,
        1.491,
        -1.238,
        -0.159,
        0.909,
        1.343,
        -0.511,
        2.037,
        -1.08,
        -0.51,
        2.231,
        0.392,
        -0.443,
        2.09,
        0.596,
        1.092,
        0.229,
        -0.168,
        1.373,
        0.385,
        0.096,
        1.115,
        0.529,
        0.78,
        1.686,
        1.389,
        0.118,
        1.726,
        1.274,
        0.241,
        1.449,
        0.95,
        0.709,
        0.581,
        1.972,
        -0.521,
        1.556,
        1.588,
        0.218,
        1.528,
        1.581,
        0.321
      ]
    },
    "castShadow": true
  },
  "sandstone_01": {
    "name": "sandstone_01",
    "geometryId": "sandstone-01",
    "lodDistances": [
      50
    ],
    "cullDistance": 800,
    "impostor": {
      "fromDistance": 120,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 8
    },
    "alignToNormal": 1,
    "yOffset": -0.52,
    "footprint": 3.9,
    "collider": {
      "type": "hull",
      "points": [
        -1.861,
        0.69,
        -0.971,
        -2.292,
        0.699,
        0,
        -2.028,
        1.125,
        1.058,
        -1.861,
        0.69,
        -0.971,
        -2.407,
        0.959,
        0,
        -2.028,
        1.125,
        1.058,
        -1.912,
        1.247,
        -0.665,
        -2.345,
        1.107,
        -0.204,
        -1.433,
        1.703,
        1.329,
        0,
        0.342,
        -1.316,
        0,
        0.001,
        0,
        0.25,
        0.53,
        1.389,
        -0.312,
        1.097,
        -1.737,
        -0.323,
        1.401,
        1.795,
        1.107,
        1.988,
        -1.232,
        0,
        2.593,
        0,
        0,
        2.104,
        1.425,
        1.982,
        0.536,
        -0.345,
        2.394,
        0.817,
        0,
        2.034,
        0.76,
        0.707,
        2.36,
        1.529,
        -0.411,
        2.499,
        1.247,
        0,
        2.205,
        0.851,
        0.575,
        1.994,
        1.843,
        -0.694,
        2.193,
        1.902,
        -0.191,
        1.327,
        2.262,
        0.554
      ]
    },
    "castShadow": true
  },
  "granite_02": {
    "name": "granite_02",
    "geometryId": "granite-02",
    "lodDistances": [
      50
    ],
    "cullDistance": 800,
    "impostor": {
      "fromDistance": 120,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 8
    },
    "alignToNormal": 1,
    "yOffset": -0.92,
    "footprint": 3.9,
    "collider": {
      "type": "hull",
      "points": [
        -1.532,
        0.755,
        -1.179,
        -2.393,
        0.946,
        0,
        -2.041,
        1.149,
        1.177,
        -1.39,
        0.901,
        -1.426,
        -2.638,
        1.566,
        0.254,
        -2.473,
        1.851,
        1.189,
        -1.3,
        3.927,
        -1.2,
        -1.232,
        4.222,
        0,
        -0.669,
        4.386,
        0.772,
        -0.281,
        0.816,
        -1.727,
        0,
        0,
        0.291,
        0.269,
        0.67,
        1.657,
        0,
        2.612,
        -2.279,
        0.312,
        1.128,
        1.919,
        -0.259,
        3.921,
        -1.594,
        -0.368,
        4.595,
        0,
        0,
        4.434,
        0.79,
        1.022,
        0.23,
        -0.524,
        1.595,
        0.364,
        0.245,
        1.93,
        1.028,
        1.113,
        1.672,
        3.184,
        -1.715,
        2.288,
        1.667,
        0.66,
        2.146,
        1.501,
        1.032,
        1.672,
        3.184,
        -1.715,
        1.896,
        3.056,
        -1.276,
        0.522,
        3.933,
        1.004
      ]
    },
    "castShadow": true
  },
  "granite_03": {
    "name": "granite_03",
    "geometryId": "granite-03",
    "lodDistances": [
      50
    ],
    "cullDistance": 800,
    "impostor": {
      "fromDistance": 120,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 8
    },
    "alignToNormal": 1,
    "yOffset": -0.87,
    "footprint": 4.6,
    "collider": {
      "type": "hull",
      "points": [
        -2.124,
        1.374,
        -1.04,
        -2.963,
        1.702,
        0,
        -2.205,
        1.037,
        1.388,
        -2.994,
        2.116,
        -0.628,
        -3.189,
        2.562,
        0,
        -2.305,
        1.955,
        1.612,
        -3.123,
        2.553,
        -0.437,
        -3.07,
        2.76,
        0,
        -2.57,
        3.015,
        1.078,
        2.02,
        0.704,
        -1.272,
        0,
        0.001,
        1.154,
        -0.435,
        0.443,
        1.841,
        0.507,
        2.897,
        -2.146,
        0.579,
        2.116,
        2.448,
        0,
        3.413,
        -1.783,
        1.306,
        4.327,
        0.804,
        1.447,
        4.156,
        1.113,
        2.19,
        0.738,
        -1.225,
        2.213,
        0.569,
        0,
        2.069,
        1.161,
        1.751,
        2.319,
        1.468,
        -1.622,
        2.533,
        2.648,
        1.24,
        2.329,
        2.279,
        1.791,
        1.311,
        2.621,
        -1.849,
        1.818,
        4.039,
        0.699,
        1.775,
        3.482,
        1.669
      ]
    },
    "castShadow": true
  },
  "sandstone_02": {
    "name": "sandstone_02",
    "geometryId": "sandstone-02",
    "lodDistances": [
      50
    ],
    "cullDistance": 800,
    "impostor": {
      "fromDistance": 120,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 8
    },
    "alignToNormal": 1,
    "yOffset": -0.94,
    "footprint": 5.4,
    "collider": {
      "type": "hull",
      "points": [
        -1.591,
        0.968,
        -2.222,
        -2.97,
        1.269,
        0,
        -1.358,
        1.096,
        2.846,
        -2.705,
        1.376,
        -1.417,
        -3.376,
        2.129,
        0.442,
        -2.841,
        2.183,
        1.86,
        -2.641,
        3.807,
        -0.692,
        -2.745,
        3.86,
        0.359,
        -2.983,
        3.074,
        1.172,
        0.354,
        1.039,
        -2.965,
        1.503,
        0.038,
        0.394,
        -0.34,
        0.818,
        2.852,
        1.17,
        2.786,
        -3.267,
        0.421,
        2.13,
        3.528,
        1.457,
        3.355,
        -3.052,
        1.709,
        4.684,
        -0.716,
        0.352,
        3.041,
        2.95,
        2.18,
        1.368,
        -2.284,
        2.745,
        0.804,
        0.359,
        2.372,
        1.511,
        2.174,
        2.235,
        2.212,
        -2.676,
        3.342,
        3.147,
        0,
        2.134,
        1.73,
        2.555,
        2.024,
        3.641,
        -2.424,
        3.055,
        3.707,
        -0.4,
        1.472,
        4.378,
        0.925
      ]
    },
    "castShadow": true
  },
  "sandstone_03": {
    "name": "sandstone_03",
    "geometryId": "sandstone-03",
    "lodDistances": [
      50
    ],
    "cullDistance": 800,
    "impostor": {
      "fromDistance": 120,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 8
    },
    "alignToNormal": 1,
    "yOffset": -0.5,
    "footprint": 6.3,
    "collider": {
      "type": "hull",
      "points": [
        -1.928,
        0.512,
        -2.034,
        -3.53,
        0.744,
        0.399,
        -3.133,
        1.026,
        2.125,
        -1.216,
        0.902,
        -2.931,
        -3.813,
        1.251,
        0.862,
        -3.41,
        1.251,
        1.927,
        -2.264,
        1.996,
        -1.462,
        -3.801,
        1.388,
        0.859,
        -3.406,
        1.374,
        1.924,
        0.49,
        0.969,
        -3.544,
        -1.605,
        0.02,
        0,
        0.481,
        0.836,
        3.482,
        0.498,
        1.251,
        -3.603,
        0,
        1.106,
        3.664,
        0.489,
        1.392,
        -3.54,
        0,
        2.498,
        -0.979,
        0.476,
        1.662,
        3.444,
        2.326,
        0.917,
        -2.804,
        3.947,
        0.968,
        0,
        2.534,
        0.939,
        2.618,
        2.162,
        1.376,
        -3.127,
        4.115,
        1.251,
        0,
        2.74,
        1.054,
        2.477,
        2.331,
        1.587,
        -2.81,
        3.815,
        1.663,
        0,
        2.274,
        1.578,
        2.741
      ]
    },
    "castShadow": true
  },
  "granite_scree_01": {
    "name": "granite_scree_01",
    "geometryId": "granite-scree-01",
    "lodDistances": [
      50
    ],
    "cullDistance": 120,
    "jitter": {
      "scale": {
        "from": 1,
        "to": 1.2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 2
    },
    "alignToNormal": 1,
    "yOffset": -0.031,
    "footprint": 3.7,
    "castShadow": false
  },
  "sandstone_cobbles_01": {
    "name": "sandstone_cobbles_01",
    "geometryId": "sandstone-cobbles-01",
    "lodDistances": [
      50
    ],
    "cullDistance": 120,
    "jitter": {
      "scale": {
        "from": 1,
        "to": 1.2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 4
    },
    "alignToNormal": 1,
    "yOffset": -0.019,
    "footprint": 2.5,
    "castShadow": false
  },
  "granite_pebble_snow_01": {
    "name": "granite_pebble_snow_01",
    "geometryId": "granite-pebble-snow-01",
    "lodDistances": [
      50
    ],
    "cullDistance": 120,
    "jitter": {
      "scale": {
        "from": 1,
        "to": 1.2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 1,
    "yOffset": -0.023,
    "footprint": 2.5,
    "castShadow": false
  },
  "sandstone_04": {
    "name": "sandstone_04",
    "geometryId": "sandstone-04",
    "lodDistances": [
      50
    ],
    "cullDistance": 800,
    "impostor": {
      "fromDistance": 120,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 8
    },
    "alignToNormal": 1,
    "yOffset": -0.57,
    "footprint": 3.5,
    "collider": {
      "type": "hull",
      "points": [
        -1.191,
        1.086,
        -1.299,
        -1.382,
        0.217,
        0.314,
        -1.404,
        0.368,
        0.684,
        -1.649,
        1.521,
        -1.124,
        -2.266,
        1.75,
        0,
        -1.99,
        1.548,
        0.509,
        -1.868,
        2.132,
        -0.478,
        -1.968,
        2.172,
        -0.168,
        -2.106,
        1.725,
        0.359,
        -0.488,
        0.147,
        -0.666,
        -0.818,
        0.002,
        0,
        -0.205,
        0.345,
        1.119,
        -0.841,
        1.568,
        -1.529,
        0.214,
        1.662,
        1.169,
        -0.428,
        2.343,
        -1.167,
        -0.284,
        2.836,
        -0.194,
        0.357,
        1.957,
        0.973,
        1.475,
        0.568,
        -0.377,
        1.52,
        0.543,
        -0.259,
        0.966,
        0.57,
        0.878,
        2.099,
        1.724,
        -0.537,
        2.099,
        1.724,
        -0.537,
        1.371,
        1.717,
        0.818,
        1.745,
        2.084,
        -0.744,
        1.837,
        2.266,
        -0.157,
        1.749,
        2.224,
        0.298
      ]
    },
    "castShadow": true
  },
  "basalt_01": {
    "name": "basalt_01",
    "geometryId": "basalt-01",
    "lodDistances": [
      50
    ],
    "cullDistance": 800,
    "impostor": {
      "fromDistance": 120,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 2
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 8
    },
    "alignToNormal": 1,
    "yOffset": -0.39,
    "footprint": 2.6,
    "collider": {
      "type": "hull",
      "points": [
        -1.137,
        0.562,
        -0.625,
        -1.417,
        0.563,
        -0.13,
        -1.262,
        0.61,
        0.578,
        -1.359,
        0.988,
        -0.623,
        -1.596,
        0.869,
        0,
        -1.222,
        0.988,
        0.784,
        -1.152,
        1.42,
        -0.634,
        -1.34,
        1.491,
        0.246,
        -1.07,
        1.47,
        0.687,
        0,
        0.297,
        -0.845,
        -0.206,
        0,
        0,
        0,
        0.479,
        0.995,
        -0.195,
        0.754,
        -1.144,
        0,
        1.11,
        1.187,
        0.146,
        1.689,
        -0.856,
        -0.205,
        1.973,
        0.15,
        0,
        1.578,
        0.961,
        1.446,
        0.663,
        -0.265,
        1.429,
        0.56,
        0.131,
        1.1,
        0.493,
        0.605,
        1.419,
        1.095,
        -0.52,
        1.605,
        0.988,
        0,
        1.213,
        0.988,
        0.779,
        1.052,
        1.462,
        -0.675,
        1.487,
        1.323,
        -0.136,
        1.202,
        1.349,
        0.661
      ]
    },
    "castShadow": true
  },
  "spruce_01": {
    "name": "spruce_01",
    "geometryId": "spruce-01",
    "lodDistances": [
      70
    ],
    "cullDistance": 2600,
    "impostor": {
      "fromDistance": 400,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 1.25
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 4.9,
    "collider": {
      "type": "capsule",
      "radius": 0.84,
      "height": 30.32,
      "offset": [
        0,
        16,
        0
      ]
    },
    "wind": {
      "amplitude": 12,
      "frequency": 0.4,
      "flutter": 0.25
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": true
  },
  "heather_01": {
    "name": "heather_01",
    "geometryId": "heather-01",
    "lodDistances": [
      40
    ],
    "cullDistance": 140,
    "impostor": {
      "fromDistance": 84,
      "views": 8,
      "tileSize": 128
    },
    "jitter": {
      "scale": {
        "from": 0.9,
        "to": 1.1
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 3
    },
    "alignToNormal": 0,
    "footprint": 2.1,
    "collider": {
      "type": "capsule",
      "radius": 0.05,
      "height": 0.1,
      "offset": [
        0,
        0.1,
        0
      ]
    },
    "wind": {
      "amplitude": 3.5,
      "frequency": 0.5,
      "flutter": 0.6
    },
    "authoredNormals": true,
    "foliage": true,
    "castShadow": false
  },
  "reed_01": {
    "name": "reed_01",
    "geometryId": "reed-01",
    "cullDistance": 520,
    "impostor": {
      "fromDistance": 120,
      "views": 4,
      "tileSize": 64
    },
    "jitter": {
      "scale": {
        "from": 1,
        "to": 1.6
      },
      "yaw": {
        "from": 0,
        "to": 360
      },
      "tilt": 4
    },
    "alignToNormal": 0.6,
    "yOffset": -0.07,
    "footprint": 1.1,
    "wind": {
      "amplitude": 1.15,
      "frequency": 0.9,
      "flutter": 0.6
    },
    "authoredNormals": false,
    "foliage": true,
    "foliageNormalMap": true,
    "castShadow": false
  }
}
